<template>
	<div class="drawer">
		<el-drawer
		size="600px"
		title="完善洗美信息"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>
			<div style="padding-bottom:40px;">
				<el-row style="padding:40px 20px 0;float: none;font-size: 16px;">
					<el-col :span="24">
						<span class="label">宠物信息</span>
					</el-col>
				</el-row>
				<el-row style="padding:20px 20px 0 80px;float: none;font-size: 14px;">
					<el-col :span="24">
						<span class="label">昵称：</span>
						<span class="value" style="color:red;">
							{{curPet.petName}} ( {{curPet.className[0]}} )
						</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 16px;">
					<el-col :span="24">
						<span class="label">用品</span>
					</el-col>
				</el-row>
				<el-row style="padding:20px 20px 0 80px;float: none;font-size: 14px;">
					<el-col :span="24">
						<span class="label">毛巾：</span>
						<span class="value">
							<el-radio-group v-model="form.maojin">
								<el-radio :label="0">无</el-radio>
								<el-radio :label="1">自带</el-radio>
								<el-radio :label="2">寄存</el-radio>
							</el-radio-group>
						</span>
					</el-col>
				</el-row>
				<el-row style="padding:20px 20px 0 80px;float: none;font-size: 14px;">
					<el-col :span="24">
						<span class="label">浴液：</span>
						<span class="value">
							<el-radio-group v-model="form.yuye">
								<el-radio :label="0">无</el-radio>
								<el-radio :label="1">自带</el-radio>
								<el-radio :label="2">寄存</el-radio>
							</el-radio-group>
						</span>
					</el-col>
				</el-row>
				<el-row style="padding:20px 20px 0 80px;float: none;font-size: 14px;">
					<el-col :span="24">
						<span class="label">药浴：</span>
						<span class="value">
							<el-radio-group v-model="form.yaoyu">
								<el-radio :label="0">无</el-radio>
								<el-radio :label="1">自带</el-radio>
								<el-radio :label="2">寄存</el-radio>
							</el-radio-group>
						</span>
					</el-col>
				</el-row>
				<el-row style="padding:20px 20px 0 80px;float: none;font-size: 14px;">
					<el-col :span="24">
						<span class="label">牙刷：</span>
						<span class="value">
							<el-radio-group v-model="form.yashua">
								<el-radio :label="0">无</el-radio>
								<el-radio :label="1">自带</el-radio>
								<el-radio :label="2">寄存</el-radio>
							</el-radio-group>
						</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 16px;">
					<el-col :span="24">
						<span class="label">体表检查项目</span>
					</el-col>
				</el-row>
				<el-row style="padding:20px 20px 0 80px;float: none;font-size: 14px;">
					<el-col :span="24">
						<span class="label">皮肤：</span>
						<span class="value">
							<el-radio-group v-model="form.skin">
								<el-radio :label="true">正常</el-radio>
								<el-radio :label="false">不正常</el-radio>
							</el-radio-group>
						</span>
					</el-col>
				</el-row>
				<el-row style="padding:20px 20px 0 80px;float: none;font-size: 14px;">
					<el-col :span="24">
						<span class="label">耳朵：</span>
						<span class="value">
							<el-radio-group v-model="form.ear">
								<el-radio :label="true">正常</el-radio>
								<el-radio :label="false">不正常</el-radio>
							</el-radio-group>
						</span>
					</el-col>
				</el-row>
				<el-row style="padding:20px 20px 0 80px;float: none;font-size: 14px;">
					<el-col :span="24">
						<span class="label">体外寄生虫：</span>
						<span class="value">
							<el-radio-group v-model="form.outSide">
								<el-radio :label="true">正常</el-radio>
								<el-radio :label="false">不正常</el-radio>
							</el-radio-group>
						</span>
					</el-col>
				</el-row>
				<el-row style="padding:20px 20px 0 80px;float: none;font-size: 14px;">
					<el-col :span="24">
						<span class="label">毛发：</span>
						<span class="value">
							<el-radio-group v-model="form.hair">
								<el-radio :label="true">正常</el-radio>
								<el-radio :label="false">不正常</el-radio>
							</el-radio-group>
						</span>
					</el-col>
				</el-row>
				<el-row style="padding:20px 20px 0 80px;float: none;font-size: 14px;">
					<el-col :span="24">
						<span class="label">眼部：</span>
						<span class="value">
							<el-radio-group v-model="form.eye">
								<el-radio :label="true">正常</el-radio>
								<el-radio :label="false">不正常</el-radio>
							</el-radio-group>
						</span>
					</el-col>
				</el-row>
				<el-row style="padding:20px 20px 0 80px;float: none;font-size: 14px;">
					<el-col :span="24">
						<span class="label">牙齿：</span>
						<span class="value">
							<el-radio-group v-model="form.tooth">
								<el-radio :label="true">正常</el-radio>
								<el-radio :label="false">不正常</el-radio>
							</el-radio-group>
						</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 16px;">
					<el-col :span="24">
						<span class="label">洗澡美容项目</span>
					</el-col>
				</el-row>
				<el-row style="padding:0 20px 0 80px;float: none;font-size: 14px;">
					<el-col :span="24">
						<span class="label" style="width: 100px;"></span>
						<span class="value" style="width:360px;display: inline-block;">
							<el-checkbox style="width:130px;padding-top:20px;" v-model="form.clearEar">拔耳毛、清耳朵</el-checkbox>
							<el-checkbox style="width:130px;padding-top:20px;" v-model="form.trimx">剪指甲</el-checkbox>
							<el-checkbox style="width:130px;padding-top:20px;" v-model="form.tijiaoDiMao">剃脚底毛</el-checkbox>
							<el-checkbox style="width:130px;padding-top:20px;" v-model="form.jiGangMenXian">挤肛门腺</el-checkbox>
							<el-checkbox style="width:130px;padding-top:20px;" v-model="form.yanHuLi">眼部护理</el-checkbox>
							<el-checkbox style="width:130px;padding-top:20px;" v-model="form.tiFuDiMao">剔腹底毛</el-checkbox>
						</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 16px;">
					<el-col :span="24">
						<span class="label">其它</span>
					</el-col>
				</el-row>
				<el-row style="padding:20px 20px 0 80px;float: none;font-size: 14px;">
					<el-col :span="24">
						<span class="label" style="vertical-align: top;">备注：</span>
						<span class="value" style="color:red;">
							<textarea class="input" v-model="form.remark" rows="4" placeholder="请输入" style="border:1px solid #ccc;padding:.04rem .1rem;font-size: .14rem;border-radius: .05rem;width:62%;display: inline-block;font-size: 16px;"></textarea>
						</span>
					</el-col>
				</el-row>
				<div>
					<el-button style="width:480px;margin:80px 0 0 80px;" type="primary" @click="submit">确 定</el-button>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				
				form:{
					"contractNum": "",
					"skin": true, // 皮肤
					"ear": true, // 耳朵
					"outSide": true, // 体外寄生虫
					"hair": true, // 毛发
					"eye": true, // 眼睛
					"tooth": true, // 牙齿
					"clearEar": true, // 清理耳朵
					"trimx": true, // 剪指甲
					"tijiaoDiMao": true, // 剃脚底毛
					"jiGangMenXian": true, // 挤肛门腺
					"yanHuLi": true, // 眼部护理
					"tiFuDiMao": true, // 剃脚底毛
					"maojin": 0, // 毛巾
					"yuye": 0, // 浴液
					"yaoyu": 0, // 药浴
					"yashua": 0, // 牙刷
					remark:'',
				},
				
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
		},
		props:{
			curPet:{
				default:()=>{
					return {}
				}
			}
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
				this.form.remark = this.curPet.remark;
				console.log(this.curPet)
			})
		},
		methods: {
			handleClose(){
				this.$emit('submit',{type:'close'})
			},
			submit(){
				let params = this.form;
				params.contractNum=this.curPet.contractNum;
				let loading = this.$loading()
				this.$http.post('/api/Contract/WashBeautyCompleteInfo', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.$message({
							message: '完善信息成功',
							type: 'success',
						});
						this.$emit('submit',{type:'success'})
						return ;
					}
				})
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.el-drawer__body{
				overflow: auto;
			}
			.avatar{
				width:220px;
				display: block;
				margin:150px auto 80px;
			}
			.label{
				display: inline-block;width:140px;text-align: right;
			}
		}
		
	}
	
</style>
